import { useRouter } from "@montana/containers/router";
import { getLanguageFromUrl } from "@montana/helpers/market.helper";
import { ISettings } from "@montana/models/generated/cms.interface";
import { fetchGlobalSettings } from "@montana/services/content";
import { useMemo } from "react";
import useSWR from "swr";

export default function useMarketSettings() {
    const { location } = useRouter();

    const market = useMemo(() => getLanguageFromUrl(location.pathname), [
        location.pathname
    ]);

    return useSWR<ISettings>(
        !!market ? `market-settings-${market}` : null,
        () => fetchGlobalSettings(market!),
        {
            dedupingInterval: 1000 * 60 * 60
        }
    );
}
